import { useEffect } from 'react'
import useAuth from 'hooks/useAuth'

import { ConnectorNames } from '../config/constants/types'
import { connectorLocalStorageKey } from '../config/constants'


const useEagerConnect = () => {
  const { login } = useAuth()

  useEffect(() => {
    const connectorId = window.localStorage.getItem(connectorLocalStorageKey) as ConnectorNames

    // Disable eager connect for Wallet.
    // into the Window object in time causing it to throw an error
    // TODO: Figure out an elegant way to listen for when the Chain object is ready
    if (connectorId) {
      login(connectorId)
    }
  }, [login])
}

export default useEagerConnect
